var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{class:_vm.classes,style:(("margin-bottom:" + _vm.marginBottom + "px;")),scopedSlots:_vm._u([(_vm.title)?{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.title))]},proxy:true}:null],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }